var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("mds-combo-box", {
    attrs: {
      label: _vm.parameter.label,
      "data-set": _vm.parameterOptions,
      "selected-items": _vm.option,
    },
    on: { input: _vm.onChangeValue },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }